import { map, set } from "lodash";
import api from "../../services/api";
import { formatRequestDate } from "../../utils/dateFns";

export const getOrdensDeCompra = (
  filters,
  pageSize
  // , orderByColumn, orderDirection
) => {
  const { dataInicio, dataFim, ...other } = filters;
  const params = {
    ...other,
    size: pageSize || 20,
  };
  // unset(params, "key");

  if (dataInicio) {
    set(params, "initDate", formatRequestDate(dataInicio));
  }
  if (dataFim) {
    set(params, "endDate", formatRequestDate(dataFim));
  }
  // if (orderByColumn) set(params, "sortColumn", orderByColumn);
  // if (orderDirection) set(params, "sortDirection", orderDirection);

  const parsedParams = new URLSearchParams(params).toString();
  return api.get(`api/ordem-compra?${parsedParams}`);
};

export const aprovarOrdensDeCompra = (rows) => {
  const data = {
    cpfUsuarioAprovacao: null,
    ordensDeCompra: map(rows, (ordem) => ({
      codEmpresa: ordem.codEmpresa,
      codOrdemCompra: ordem.codOrdemCompra,
    })),
  };

  return api.post(`api/ordem-compra/aprovacao`, data);
};
